import { render, staticRenderFns } from "./DashNode.vue?vue&type=template&id=0bfa0108&scoped=true"
import script from "./DashNode.vue?vue&type=script&lang=ts"
export * from "./DashNode.vue?vue&type=script&lang=ts"
import style0 from "./DashNode.vue?vue&type=style&index=0&id=0bfa0108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfa0108",
  null
  
)

export default component.exports